import { Empty } from 'antd';
import PropTypes, { any } from 'prop-types';
import React from 'react';

function DataNotFound({ message, children, ...props }) {
  return (
    <div className="p-4 text-danger font600 text-uppercase">
      <Empty
        description={<span className="fw-bold text-danger">{message}</span>}
        {...props}
      />
      {children}
    </div>
  );
}
DataNotFound.defaultProps = {
  children: null,
  message: 'Data Not Found',
};

DataNotFound.propTypes = {
  message: PropTypes.string,
  children: PropTypes.oneOf([any]),
};

export default DataNotFound;
